import React, {Component} from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import withRouter from '../Functions/WithRouter';

const closeIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/close-icon.png';
const courseIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/course-icon-blue.png';
const deniedIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/denied-icon.png";
const profileIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/profile-icon-blue.png';
const loadingGIF = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/loading-gif.gif';

class EditEnrollment extends Component {
    constructor(props) {
      super(props)

      this.state = {
        caseManagerOptions: [],
        stageOptions: ['', 'Enrolled','Completed','Dropped']
      }

      this.deleteItem = this.deleteItem.bind(this)
      this.saveChanges = this.saveChanges.bind(this)

      this.retrieveData = this.retrieveData.bind(this)
      this.suggestedItemClicked = this.suggestedItemClicked.bind(this)
      this.addItem = this.addItem.bind(this)

      this.unloadEnrollment = this.unloadEnrollment.bind(this)
      this.searchAssignees = this.searchAssignees.bind(this)
    }

    componentDidMount() {
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const selectedAssignee = this.props.selectedProfile
      const selectedEnrollment = this.props.selectedEnrollment

      const emailId = localStorage.getItem('email');
      // const username = localStorage.getItem('username');
      // const cuFirstName = localStorage.getItem('firstName');
      // const cuLastName = localStorage.getItem('lastName');
      // const pictureURL = localStorage.getItem('pictureURL');
      // const orgFocus = localStorage.getItem('orgFocus');
      const orgName = localStorage.getItem('orgName');

      let delegateAdminEmail = emailId
      if (selectedAssignee && selectedAssignee.email !== emailId) {
        delegateAdminEmail = emailId
      } else {
        delegateAdminEmail = ""
      }

      const activeOrg = localStorage.getItem('activeOrg');

      this.setState({ selectedAssignee, emailId, delegateAdminEmail, orgCode: activeOrg, orgName })

      if (selectedEnrollment) {
        this.unloadEnrollment(selectedEnrollment)
      }

      const roleNames = ['Admin']
      Axios.get('/api/org/members', { params: { orgCode: activeOrg, roleNames } })
      .then((response) => {
        if (response.data.success) {
          console.log('Member query worked', response.data);

          if (response.data.members && response.data.members.length > 0) {

            let caseManagerOptions = response.data.members
            if (caseManagerOptions) {
              caseManagerOptions.unshift({})

              this.setState({ caseManagerOptions })

            }
          }

        } else {
          console.log('no members found', response.data.message)
        }
      }).catch((error) => {
          console.log('Members query did not work', error);
      });
    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called in commonEditEnrollment', this.props.activeOrg, prevProps)

      if (this.props.activeOrg !== prevProps.activeOrg) {
        this.retrieveData()
      }
    }

    retrieveData() {
      console.log('retrieveData called in commonEditEnrollment', this.props)

    }

    unloadEnrollment(selectedEnrollment) {
      console.log('unloadEnrollment called')

      const _id = selectedEnrollment._id
      const selectedAssignee = {
        firstName: selectedEnrollment.firstName,
        lastName: selectedEnrollment.lastName,
        email: selectedEnrollment.email,
        username: selectedEnrollment.username,
        pictureURL: selectedEnrollment.pictureURL,
        roleName: selectedEnrollment.roleName,
      }

      const delegateAdminEmail = selectedEnrollment.delegateAdminEmail
      const enrollmentType = selectedEnrollment.enrollmentType

      const selectedProgram = {
        _id: selectedEnrollment.courseId,
        title: selectedEnrollment.courseName,
        selectedTrainer: { employerName: selectedEnrollment.courseSchoolName },
        description: selectedEnrollment.courseDescription,
        location: selectedEnrollment.courseLocation,
        category: "Program"
      }

      const cohort = selectedEnrollment.cohort

      let caseManagerName = undefined
      if (selectedEnrollment.caseManager) {
        caseManagerName = selectedEnrollment.caseManager.firstName + " " + selectedEnrollment.caseManager.lastName
      }

      const stage = selectedEnrollment.stage
      const isSubsidyEligible = selectedEnrollment.isSubsidyEligible

      let enrollmentObject = {
        _id, selectedAssignee, delegateAdminEmail, enrollmentType, selectedProgram,
        cohort, caseManagerName, stage, isSubsidyEligible,
      }

      // if a program is selected, get the latest cohort options
      if (selectedProgram) {
        console.log('show program: ', selectedProgram)
        Axios.get('/api/programs/byid', { params: { _id: selectedProgram._id } })
        .then((response) => {
          if (response.data.success) {
            console.log('Program query worked', response.data);

            if (response.data.program) {

              let selectedProgram = response.data.program
              selectedProgram['category'] = "Program"
              enrollmentObject['selectedProgram'] = selectedProgram
              this.setState(enrollmentObject)
            }

          } else {
            console.log('no members found', response.data.message)
          }
        }).catch((error) => {
            console.log('Members query did not work', error);
        });
      } else {
        this.setState(enrollmentObject)
      }


    }

    formChangeHandler = (event) => {
      console.log('formChangeHandler clicked', event.target.name, event.target.value)

      if (event.target.name === 'assigneeName') {
        const assigneeName = event.target.value
        this.setState({ assigneeName })
        this.searchAssignees(assigneeName)
      } else if (event.target.name === 'programTitle') {
        const programTitle = event.target.value
        this.setState({ programTitle })
        this.searchPrograms(programTitle)
      } else {
        this.setState({ [event.target.name]: event.target.value })
      }
    }

    searchAssignees(assigneeName) {
      console.log('searchAssignees called', assigneeName, this.state.orgCode)

      this.setState({ isSaving: true, isLoadingAssignees: true })

      const orgCode = this.state.orgCode

      const self = this
      function officiallyFilter() {
        console.log('officiallyFilter called')

        Axios.get('/api/assignee/search', { params: { assigneeName, orgCode } })
        .then((response) => {
          console.log('Assignee search query attempted', response.data);

            if (response.data.success) {
              console.log('assignee search query worked')

              const suggestedAssignees = response.data.assignees
              self.setState({ suggestedAssignees, isSaving: false, isLoadingAssignees: false });

            } else {
              console.log('assignee search query did not work', response.data.message)
              const suggestedAssignees = []
              self.setState({ suggestedAssignees, isSaving: false, isLoadingAssignees: false })
            }

        }).catch((error) => {
            console.log('Assignee search query did not work for some reason', error);
        });
      }

      const delayFilter = () => {
        console.log('delayFilter called: ')
        clearTimeout(self.state.timerId)
        self.state.timerId = setTimeout(officiallyFilter, 1000)
      }

      delayFilter();
    }

    searchPrograms(searchString) {
      console.log('searchPrograms called', searchString)

      this.setState({ isSaving: true, isLoadingPrograms: true })

      const orgCode = this.state.orgCode


      const self = this
      function officiallyFilter() {
        console.log('officiallyFilter called')

        Axios.get('/api/programs/search', { params: { searchString, orgCode } })
        .then((response) => {
          console.log('Program search query attempted', response.data);

            if (response.data.success) {
              console.log('program search query worked')

              const suggestedPrograms = response.data.programs
              self.setState({ suggestedPrograms, isSaving: false, isLoadingPrograms: false });

            } else {
              console.log('program search query did not work', response.data.message)
              const suggestedPrograms = []
              self.setState({ suggestedPrograms, isSaving: false, isLoadingPrograms: false })
            }

        }).catch((error) => {
            console.log('Programs search query did not work for some reason', error);
        });
      }

      const delayFilter = () => {
        console.log('delayFilter called: ')
        clearTimeout(self.state.timerId)
        self.state.timerId = setTimeout(officiallyFilter, 1000)
      }

      delayFilter();
    }

    addItem(type) {
      console.log('addItem called')

      if (type === 'program') {
        if (this.state.program) {
          let program = this.state.program
          let selectedProgram = this.state.program
          program = null
          let programTitle = ''
          this.setState({ selectedProgram, program, programTitle })
        }
      } else if (type === 'assignee') {
        if (this.state.assignee) {
          let assignee = this.state.assignee
          let selectedAssignee = this.state.assignee
          assignee = null
          let assigneeName = ''
          let suggestedAssignees = []
          this.setState({ selectedAssignee, assignee, assigneeName, suggestedAssignees })
        }
      }
    }

    suggestedItemClicked(type, value) {
      console.log('suggestedItemClicked called ', type, value)

      if (type === 'program') {
        const suggestedPrograms = []
        const programTitle = value.title

        this.setState({ suggestedPrograms, program: value, programTitle })
      } else if (type === 'assignee') {
        const suggestedAssignees = []
        const assigneeName = value.firstName + ' ' + value.lastName

        this.setState({ suggestedAssignees, assignee: value, assigneeName })
      }
    }

    toggleConfirmDelete() {
      console.log('toggleConfirmDelete called')

      this.setState({ confirmDelete: !this.state.confirmDelete })
    }

    renderConfirmDeleteWidget(type) {
      console.log('renderConfirmDeleteWidget called', type)

      return (
        <div key="renderConfirmDeleteWidget">
          <div>
            <p className={"row-10 description-text-2"}>Are you sure you want to delete? It may be better to just change the stage!</p>
            <button type="button" className={"btn btn-squarish error-background-color error-border right-margin-20"} onClick={() => this.deleteItem(type)}>Yes, Delete</button>
            <button type="button" className={"btn btn-squarish white-background cta-color"} onClick={() => this.toggleConfirmDelete()}>Cancel</button>
          </div>
          <div className="clear" />
        </div>
      )
    }

    deleteItem(type) {
      console.log('deleteItem called', type)

      const _id = this.state._id

      Axios.delete('/api/courses/enrollments/' + _id)
      .then((response) => {
        console.log('tried to delete', response.data)
        if (response.data.success) {

          if (this.props.passData) {
            this.props.passData('enrollment',{ _id },true)
          }

          if (this.props.closeModal) {
            this.props.closeModal()
          }

        } else {
          console.error('there was an error deleting the posting');
          this.setState({ errorMessage: response.data.message })
        }
      }).catch((error) => {
          console.log('The deleting did not work', error);
          this.setState({ errorMessage: error.toString() })
      });
    }

    saveChanges() {
      console.log('saveChanges called')

      this.setState({ isSaving: true, errorMessage: null, successMessage: null })

      if (!this.state.selectedProgram) {
        this.setState({ errorMessage: 'please add a program', isSaving: false })
      } else if (!this.state.stage || this.state.stage === '') {
        this.setState({ errorMessage: 'please add an enrollment stage', isSaving: false })
      } else {

        const _id = this.state._id

        const firstName = this.state.selectedAssignee.firstName
        const lastName = this.state.selectedAssignee.lastName
        const email = this.state.selectedAssignee.email
        const username = this.state.selectedAssignee.username
        const pictureURL = this.state.selectedAssignee.pictureURL
        const roleName = this.state.selectedAssignee.roleName

        const delegateAdminEmail = this.state.delegateAdminEmail

        const enrollmentType = "Program"

        const courseId = this.state.selectedProgram._id
        const courseName = this.state.selectedProgram.title
        let courseSchoolName = this.state.selectedProgram.schoolName
        if (this.state.selectedProgram.selectedTrainer) {
          courseSchoolName = this.state.selectedProgram.selectedTrainer.employerName
        }
        const courseDescription = this.state.selectedProgram.description
        const courseLocation = this.state.selectedProgram.location
        const courseCategory = enrollmentType

        const cohort = this.state.cohort

        let caseManager = undefined
        if (this.state.caseManagerName) {
          for (let i = 1; i <= this.state.caseManagerOptions.length; i++) {
            const item = this.state.caseManagerOptions[i - 1]
            if (item.firstName + " " + item.lastName === this.state.caseManagerName) {
              caseManager = { firstName: item.firstName, lastName: item.lastName, email: item.email, username: item.username }
            }
          }
        }

        const stage = this.state.stage
        const isSubsidyEligible = this.state.isSubsidyEligible

        const orgCode = this.state.orgCode
        const orgName = this.state.orgName

        const syncOptionals = true

        const createdAt = new Date()
        const updatedAt = new Date()

        const enrollmentObject = {
          _id, firstName, lastName, email, username, pictureURL, roleName, delegateAdminEmail,
          enrollmentType, courseId, courseName, courseSchoolName, courseDescription, courseLocation, courseCategory,
          cohort, caseManager, stage, isSubsidyEligible,
          orgCode, orgName, syncOptionals, createdAt, updatedAt
        }

        console.log('show enrollmentObject: ', enrollmentObject)

        Axios.post('/api/courses/enrollments', enrollmentObject)
        .then((response) => {

          if (response.data.success) {
            console.log('Enrollment save worked', response.data);

            this.setState({ successMessage: response.data.message, isSaving: false })

            if (this.props.passData) {
              this.props.passData('enrollment',enrollmentObject)
            }

            if (this.props.closeModal) {
              this.props.closeModal()
            }

          } else {
            console.error('there was an error saving the enrollment');
            this.setState({ errorMessage: response.data.message, isSaving: false})
          }
        }).catch((error) => {
            console.log('The enrollment save did not work', error);
            this.setState({ errorMessage: error, isSaving: false })
        });
      }
    }

    switchPreferences(change, shortname) {
      console.log('switchPreferences called', change, shortname)

      this.setState({ [shortname]: change })

    }

    render() {

      return (
          <div>
            <div className="spacer" />
            <div className="row-10">
              <div>
                <div className="calc-column-offset-20">
                  <p className="heading-text-3">{(this.state._id) ? "Edit" : "Add"} Enrollment {(this.state.selectedAssignee) ? " for " + this.state.selectedAssignee.firstName + " " + this.state.selectedAssignee.lastName : ""}</p>
                </div>
                <div className="fixed-column-20">
                  <button type="button" className="background-button full-width right-text" onClick={() => this.props.closeModal()}>
                    <img src={closeIcon} alt="GC" className="image-auto-15 pin-right" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Close modal"/>
                  </button>
                </div>
                <div className="clear" />
              </div>
            </div>
            {/* Select program or course
            <div className="row-10">
              <div className="container-left">
                <p className="profile-label"> {this.state.orgName}'s list <label className="error-color">*</label></p>
                <select name={"addCertificateMethod"} value={this.state.addCertificateMethod} onChange={this.formChangeHandler} className="dropdown">
                  {this.state.addCertificateMethodOptions.map(value =>
                    <option key={value} value={value}>{value}</option>
                  )}
                </select>
              </div>
              <div className="container-right">
              </div>
              <div className="clear" />
            </div>
            */}

            {/*<p>program or course, case manager, wioa eligible, enrollment status/stage</p>*/}

            <div className="row-20">
              <div className="row-15">
                <label className="profile-label">Selected Member</label>

                <div>
                  <div className="calc-column-offset-100 right-padding">
                    <input type="text" className="text-field" placeholder="Search a name or email..." name="assigneeName" value={this.state.assigneeName} onChange={this.formChangeHandler}></input>
                  </div>
                  <div className="fixed-column-100">
                    <button className="btn btn-squarish" onClick={() => this.addItem('assignee')}>Add</button>
                  </div>
                  <div className="clear" />
                </div>

                <div className="clear" />
                <div className="spacer" />

                {(this.state.isLoadingAssignees) ? (
                  <div className="flex-container flex-center full-space">
                    <div>
                      <div className="super-spacer" />

                      <img src={loadingGIF} alt="GC" className="image-auto-80 center-horizontally"/>
                      <div className="spacer" /><div className="spacer" /><div className="spacer" />
                      <p className="center-text cta-color bold-text">Searching members...</p>

                    </div>
                  </div>
                ) : (
                  <div>
                    {(this.state.suggestedAssignees && this.state.suggestedAssignees.length > 0) && (
                      <div>
                        <div className="spacer" />
                        {this.state.suggestedAssignees.map(value =>
                          <div key={value._id} className="row-5">
                            <button className="background-button" onClick={() => this.suggestedItemClicked('assignee',value)}>
                              <div>
                                <div className="float-left right-padding">
                                  <img src={profileIconBlue} alt="Compass employer icon icon" className="image-auto-22" />
                                </div>
                                <div className="float-left">
                                  <p className="cta-color">{value.firstName} {value.lastName} ({value.email})</p>
                                </div>
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {(this.state.selectedAssignee) && (
                  <div key={"selectedAssignee"} className="float-left">
                    <div className="close-button-container-1">
                      <button className="background-button" onClick={() => this.setState({ selectedAssignee: null })}>
                        <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="float-left row-5 right-padding">
                      <div className="tag-container-5">
                        <p className="description-text-2"></p>
                        <Link className="description-text-2" to={"/organizations/" + this.state.orgCode + "/members/" + this.state.selectedAssignee.username} target="_blank" rel="noopener noreferrer">{this.state.selectedAssignee.firstName} {this.state.selectedAssignee.lastName} ({this.state.selectedAssignee.email})</Link>
                      </div>
                    </div>
                  </div>
                )}

                <div className="clear" />
              </div>

              <div className="row-15">
                <label className="profile-label">Selected Program</label>

                <div>
                  <div className="calc-column-offset-100 right-padding">
                    <input type="text" className="text-field" placeholder="Search by program name..." name="programTitle" value={this.state.programTitle} onChange={this.formChangeHandler}></input>
                  </div>
                  <div className="fixed-column-100">
                    <button className="btn btn-squarish" onClick={() => this.addItem('program')}>Add</button>
                  </div>
                  <div className="clear" />
                </div>

                <div className="clear" />
                <div className="spacer" />

                {(this.state.isLoadingPrograms) ? (
                  <div className="flex-container flex-center full-space">
                    <div>
                      <div className="super-spacer" />

                      <img src={loadingGIF} alt="GC" className="image-auto-80 center-horizontally"/>
                      <div className="spacer" /><div className="spacer" /><div className="spacer" />
                      <p className="center-text cta-color bold-text">Searching programs...</p>

                    </div>
                  </div>
                ) : (
                  <div>
                    {(this.state.suggestedPrograms && this.state.suggestedPrograms.length > 0) && (
                      <div>
                        <div className="spacer" />
                        {this.state.suggestedPrograms.map(value =>
                          <div key={value._id} className="row-5">
                            <button className="background-button" onClick={() => this.suggestedItemClicked('program',value)}>
                              <div>
                                <div className="float-left right-padding">
                                  <img src={courseIconBlue} alt="Compass employer icon icon" className="image-auto-22" />
                                </div>
                                <div className="float-left">
                                  <p className="cta-color">{value.title}</p>
                                </div>
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {(this.state.selectedProgram) && (
                  <div key={"selectedProgram"} className="float-left">
                    <div className="close-button-container-1">
                      <button className="background-button" onClick={() => this.setState({ selectedProgram: null })}>
                        <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="float-left row-5 right-padding">
                      <div className="tag-container-5">
                        <p className="description-text-2">{this.state.selectedProgram.title}</p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="clear" />
              </div>

              <div className="row-15">
                <div className="container-left">
                  <p className="profile-label">Enrollment Stage <label className="error-color">*</label></p>
                  <select name={"stage"} value={this.state.stage} onChange={this.formChangeHandler} className="dropdown">
                    {this.state.stageOptions.map(value =>
                      <option key={value} value={value}>{value}</option>
                    )}
                  </select>
                </div>
                {(this.state.selectedProgram) && (
                  <div className="container-right">
                    {(this.state.selectedProgram.cohorts && this.state.selectedProgram.cohorts.length > 0) && (
                      <div>
                        <p className="profile-label">Cohort</p>
                        <select name={"cohort"} value={this.state.cohort} onChange={this.formChangeHandler} className="dropdown">
                          {[{ name: ""}].concat(this.state.selectedProgram.cohorts).map(value =>
                            <option key={(value.name) ? value.name : ""} value={(value.name) ? value.name : ""}>{(value.name) ? value.name : ""}</option>
                          )}
                        </select>
                      </div>
                    )}
                  </div>
                )}

                <div className="clear" />
              </div>

              <div className="row-15">
                <div className="container-left">
                  <p className="profile-label">Assign a Case Manager</p>
                  <select name={"caseManagerName"} value={this.state.caseManagerName} onChange={this.formChangeHandler} className="dropdown">
                    {this.state.caseManagerOptions.map(value =>
                      <option key={(value.username) ? value.username : "cmo"} value={(value.username) ? value.firstName + " " + value.lastName : ""}>{(value.username) ? value.firstName + " " + value.lastName : ""}</option>
                    )}
                  </select>
                </div>
                <div className="container-right">
                  <p className="profile-label">WIOA Eligible</p>
                  <Switch
                    onChange={(change) => this.switchPreferences(change,'isSubsidyEligible')}
                    checked={this.state.isSubsidyEligible}
                    id="normal-switch"
                    disabled={this.state.isSaving}
                  />
                </div>
                <div className="clear" />
              </div>
            </div>

            <div className="top-margin-20">
              {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-color description-text-2 row-5">{this.state.errorMessage}</p>}
              {(this.state.successMessage && this.state.successMessage !== '') && <p className="cta-color description-text-2 row-5">{this.state.successMessage}</p>}

              {(this.state.confirmDelete) ? (
                <div className="top-margin">
                  {this.renderConfirmDeleteWidget()}
                </div>
              ) : (
                <div className="top-margin">
                  <button className="btn btn-primary right-margin" disabled={this.state.isSaving} onClick={() => this.saveChanges()}>Save Changes</button>
                  {(this.state._id) && (
                    <button className="btn btn-quaternary" disabled={this.state.isSaving} onClick={() => this.toggleConfirmDelete()}>Delete Enrollment</button>
                  )}
                </div>
              )}
            </div>

          </div>

      )
    }
}

export default withRouter(EditEnrollment);